module.exports = __webpack_public_path__ + "media/images/affiliates/feature-1-16579323534a3d57d50575cca6e40321.jpg";